import { render } from "./Servicio.vue?vue&type=template&id=6fc4bcde"
import script from "./Servicio.vue?vue&type=script&lang=js"
export * from "./Servicio.vue?vue&type=script&lang=js"
script.render = render

export default script